import React from 'react';
import './Navbar.css';
import { useNavigate } from "react-router-dom";

const Navbar = () => {
  const navigate = useNavigate();
  const handleLogout = async (e) => {
    e.preventDefault();
    const token = localStorage.getItem('token');
    try {
      if(token) {
        localStorage.setItem("token", "");
        navigate("/login");
      }
    } catch (err) {
    }
  };
  return (

<nav className="navbar">
  <div className="navbar-left">
    <a href="/" className="logo">
      <img src="https://cdn.shopify.com/s/files/1/0885/8927/1316/files/logo_6749f566-b201-4389-bab5-4a2a8fc7abd7.png?v=1724386030" alt="" />
    </a>
  </div>
  <div className="navbar-center">
    <ul className="nav-links">
    { localStorage.getItem('token')?(<>
      {/*<li><a href="/">Home</a></li>
      <li><a href="https://ozwashroom.com.au/" target="_blank" rel="noreferrer">Store View</a></li> */}
      <li><a href="!#" onClick={handleLogout}><strong>Logout</strong></a></li> </>): ""}
      {/*<li><a href="/freeship">Free Ship</a></li>
      <li><a href="/sameday">Same Day Delivery</a></li>
      <li><a href="/pickupconfig">Pickup</a></li>*/}
    </ul>
  </div>
</nav>
);
};

export default Navbar;